import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class CanditatureSourcesService {
  public list: { id: number; name: string }[] = [];

  public baseUrl: string = "/candidate-sources";

  constructor(private _httpClient: HttpClient) {}

  async getList() {
    return this._httpClient
      .get(this.baseUrl)
      .toPromise()
      .then((response: { id: number; name: string }[]) => {
        this.list = response;
        return response;
      })
      .catch((err) => {
        console.error(err);
        return [];
      });
  }

  async create(data: { name: string }) {
    return this._httpClient
      .post(this.baseUrl, data)
      .toPromise()
      .then(async (response) => {
        await this.getList();
        return response;
      });
  }

  async update(id: number, data: { name: string }) {
    return this._httpClient
      .put(this.baseUrl + "/" + id, data)
      .toPromise()
      .then(async () => {
        await this.getList();
      });
  }

  async delete(id: number) {
    return this._httpClient
      .delete(this.baseUrl + "/" + id)
      .toPromise()
      .then(async (response) => {
        await this.getList();
        return response;
      });
  }
}
